export default __webpack_public_path__ + "static/media/vsline.b2d03af9.png";